import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import {Link} from "@mui/material";
import {useNavigate} from "react-router-dom";




export default function AccountMenu({name,phone,setLogout,isSmall}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate()
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  function HandleAcc(){
    navigate('/account')
  }
  
  
  function handleLogOut(){
      setLogout(true)
  }
  const handleClose = () => {
    setAnchorEl(null);
  };

  //            onClick={handleClick}
  return (
            <div className="profile_log ">

              <div className="user" onClick={handleClick}>

                {isSmall ?
                <></>

                :
                
                <span className="thumb">

                <img src={'./icons/mobile/info.svg'} alt=''/>
                                                           </span>


              }
                                                            <span className={isSmall? 'fmt4242' : 'text-large'}>{name ? name : phone}</span>



                                                            {isSmall?



<span className="arrow pl-1">
<svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 11.5 5.5">
<path id="Vector" d="M11.533,1.528A.75.75,0,1,0,10.467.472L8.72,2.235A22.059,22.059,0,0,1,7.109,3.773a1.8,1.8,0,0,1-.891.463,1.728,1.728,0,0,1-.437,0,1.8,1.8,0,0,1-.891-.463A22.055,22.055,0,0,1,3.28,2.235L1.533.472A.75.75,0,0,0,.467,1.528L2.246,3.323a22.65,22.65,0,0,0,1.705,1.62,3.259,3.259,0,0,0,1.64.781,3.228,3.228,0,0,0,.816,0,3.259,3.259,0,0,0,1.64-.781,22.646,22.646,0,0,0,1.705-1.62Z" transform="translate(-0.25 -0.25)" fill="#2d264b"/>
</svg>
</span>


:



<span className="arrow pl-2">
<svg xmlns="http://www.w3.org/2000/svg" width="11.5" height="5.5" viewBox="0 0 11.5 5.5">
<path id="Vector" d="M11.533,1.528A.75.75,0,1,0,10.467.472L8.72,2.235A22.059,22.059,0,0,1,7.109,3.773a1.8,1.8,0,0,1-.891.463,1.728,1.728,0,0,1-.437,0,1.8,1.8,0,0,1-.891-.463A22.055,22.055,0,0,1,3.28,2.235L1.533.472A.75.75,0,0,0,.467,1.528L2.246,3.323a22.65,22.65,0,0,0,1.705,1.62,3.259,3.259,0,0,0,1.64.781,3.228,3.228,0,0,0,.816,0,3.259,3.259,0,0,0,1.64-.781,22.646,22.646,0,0,0,1.705-1.62Z" transform="translate(-0.25 -0.25)" fill="#2d264b"/>
</svg>
</span>
}


                                                        </div>


                           <React.Fragment>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={HandleAcc}>
                <Link to="/Account" className="dropdown-item text-large ">
                                                                <img src='./icons/mobile/info.svg' alt=''/>
                                                                <span className='pl-2'>
                                                                حساب کاربری
                                                                  
                                                                  </span>  
                                                            </Link>
        </MenuItem>

        <MenuItem onClick={handleLogOut}>

                    <div href="#"
                       className="dropdown-item logout text-large ">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5">
  <g id="logout" transform="translate(-0.25 -0.25)">
    <path id="Path_17" data-name="Path 17" d="M6.919.25A12.412,12.412,0,0,0,5.1.321,5.75,5.75,0,0,0,.321,5.1,12.413,12.413,0,0,0,.25,6.919v6.162A12.413,12.413,0,0,0,.321,14.9a5.75,5.75,0,0,0,4.78,4.78,12.409,12.409,0,0,0,1.819.071H8a5.728,5.728,0,0,0,3.45-1.15.75.75,0,1,0-.9-1.2A4.228,4.228,0,0,1,8,18.25H7A12.107,12.107,0,0,1,5.335,18.2,4.25,4.25,0,0,1,1.8,14.665,12.108,12.108,0,0,1,1.75,13V7A12.107,12.107,0,0,1,1.8,5.335,4.25,4.25,0,0,1,5.335,1.8,12.107,12.107,0,0,1,7,1.75H8a4.228,4.228,0,0,1,2.55.849.75.75,0,1,0,.9-1.2A5.728,5.728,0,0,0,8,.25Z" fill="#2d264b"/>
    <path id="Path_18" data-name="Path 18" d="M15.466,5.412a.75.75,0,0,0-.932,1.175l1.763,1.4c.7.558,1.186.942,1.513,1.264H5a.75.75,0,1,0,0,1.5H17.81c-.327.323-.809.706-1.513,1.264l-1.763,1.4a.75.75,0,0,0,.932,1.175l1.8-1.426a20.642,20.642,0,0,0,1.623-1.367,2.615,2.615,0,0,0,.833-1.426,2.342,2.342,0,0,0,0-.737,2.615,2.615,0,0,0-.833-1.426,20.623,20.623,0,0,0-1.623-1.367Z" fill="#2d264b"/>
  </g>
</svg>
<span className='pl-2'>
خروج

</span>
 
                    </div>
        </MenuItem>
      </Menu>
    </React.Fragment>
            </div>
  );
}
